﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ISphereNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.SphereNode,
})
export class SphereNode extends PrimitiveMeshNode implements ISphereNode {
    public constructor() {
        super();
    }

    public tessellation: number;
    public radius: number;
    public arc: number;
    public latitudeStart: number;
    public latitudeSlice: number;
}

export function isSphereMesh(node: Kb3dObject): node is SphereNode {
    return instanceOf(node, Token.SphereNode);
}
